import { Component, inject } from '@angular/core';
import { ReferralBannerService } from '@core-mkt/services/referral-banner/referral-banner.service';

@Component({
  selector: 'referral-banner',
  standalone: true,
  template: `
    @if (referralBannerService.isReferralVisitor()) {
    <div
      class="referral-banner mx-auto my-4 flex max-w-[600px] items-center gap-3 rounded-lg border border-vis-brand-1 bg-vis-alt-1 px-6 py-4"
    >
      <span class="text-[2rem] leading-none">🎉</span>
      <div>
        <p class="mb-0.5 text-base font-bold text-vis-brand-1">You're getting a referral discount!</p>
        <p class="text-sm text-vis-regular">See your discount at checkout.</p>
      </div>
    </div>
    }
  `,
})
export class ReferralBannerComponent {
  readonly referralBannerService = inject(ReferralBannerService);
}
